<div class="progress-bar-complete" 
  [style.width]="completionBarSize() + '%'" role="progressbar" 
  [attr.data-qa]="testIdPrefix() + '-' + completionBarSize()"
  [attr.aria-valuenow]="completionBarSize()" 
  aria-valuemin="0" 
  aria-valuemax="100">
</div>